// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"610":"b02fdfbc","618":"f323b0a5","758":"74c5cad3"}[chunkId] + ".chunk.js";
};